interface LoadMoreProps extends React.HTMLAttributes<HTMLDivElement> {
  text: React.ReactNode;
  icon: React.ReactNode;
  className?: string;
}

const LoadMore = ({ text, icon, className = '', ...props }: LoadMoreProps) => {
  return (
    <div className={`w-full h-[32px] rounded-[6px] py-[8px] bg-separator1 ${className}`} {...props}>
      <div className="flex flex-row gap-[4px] items-center justify-center">
        {text}
        {icon}
      </div>
    </div>
  );
};

export default LoadMore;
